var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DevPlanContainer, DevPlanGrid, DevPlanPageLoadingDiv, DevPlanPageNotAvailableDiv, } from './styles';
import OrganizationDeveloperPlanCard from '../../components/DeveloperPlans/OrganizationDeveloperPlanCard';
import { LoadingSpinner, ModalText } from '../base';
import { DEV_PLAN_INTERVAL } from '../../store/configureAccount/types';
import RadioBadge from '../Forms/Fields/RadioBadge/gray';
export var ConfigureAccountDevPlanSelectionModal = function (_a) {
    var _b;
    var configureAccount = _a.configureAccount, developerPlans = _a.developerPlans, setSelectedDevPlanId = _a.setSelectedDevPlanId, setDevPlanInterval = _a.setDevPlanInterval, setSelectedDevPlanTrialPeriod = _a.setSelectedDevPlanTrialPeriod;
    var devPlansLoading = configureAccount.devPlansLoading, selectedDevPlanId = configureAccount.selectedDevPlanId, devPlanInterval = configureAccount.devPlanInterval;
    var setExistingDevPlanAsSelected = function (plan) {
        if (plan === null || plan === void 0 ? void 0 : plan.active_dev_plan) {
            setSelectedDevPlanId(plan.id);
        }
        return plan;
    };
    var setSubscription = function (id, trial) {
        if (id === void 0) { id = ''; }
        if (trial === void 0) { trial = 0; }
        setSelectedDevPlanId(id);
        setSelectedDevPlanTrialPeriod(trial);
    };
    return (_jsxs(_Fragment, { children: [_jsx(RadioBadge, { selected: devPlanInterval, options: [
                    { value: DEV_PLAN_INTERVAL.MONTHLY, label: 'Monthly' },
                    { value: DEV_PLAN_INTERVAL.ANNUALLY, label: 'Annually' },
                ], onChange: function (e) { return setDevPlanInterval(e); } }), !devPlansLoading ? (_jsx(DevPlanGrid, { children: _jsx(DevPlanContainer, { children: developerPlans ? ((_b = developerPlans
                        .map(function (plan) {
                        return !selectedDevPlanId
                            ? setExistingDevPlanAsSelected(plan)
                            : __assign(__assign({}, plan), { active_dev_plan: false });
                    })) === null || _b === void 0 ? void 0 : _b.map(function (plan) { return (_jsx(OrganizationDeveloperPlanCard, { data: plan.id === selectedDevPlanId
                            ? __assign(__assign({}, plan), { active_dev_plan: true, interval: devPlanInterval }) : __assign(__assign({}, plan), { interval: devPlanInterval }), signup: true, onSubscribeButtonClick: function (data) {
                            if (selectedDevPlanId === data.id) {
                                setSubscription();
                            }
                            else {
                                setSubscription(data.id, data.trial_period);
                            }
                        } }, plan.id)); })) : (_jsx(DevPlanPageNotAvailableDiv, { children: _jsx(ModalText, { children: "No Developer Plan Available for Purchase" }) })) }) })) : (_jsx(DevPlanPageLoadingDiv, { children: _jsx(LoadingSpinner, {}) }))] }));
};
